<template>

<div class="input" v-if="isVisible" :class="{'is-locked': isLocked, 'is-dark': dark, 'is-stacked': input.layout.stacked || input.type === $constants.input.type.checklist}">

	<div class="input-label" v-if="input.text.label">

		<div class="input-label-title">{{ input.text.label }}</div>

		<div class="input-label-description" v-if="input.text.summary">{{ input.text.summary }}</div>

	</div>

	<div class="input-content">

		<com-toggle v-if="input.type === $constants.input.type.toggle" :input="input" :flag="flag" v-on:change="onChange" />
		<com-textbox v-if="input.type === $constants.input.type.textbox" :input="input" :flag="flag" v-on:change="onChange" />
		<com-date v-if="input.type === $constants.input.type.date" :input="input" :flag="flag" v-on:change="onChange" />
		<com-select v-if="input.type === $constants.input.type.select" :input="input" :flag="flag" v-on:change="onChange" />
		<com-scale v-if="input.type === $constants.input.type.scale" :input="input" :flag="flag" v-on:change="onChange" />
		<com-checklist v-if="input.type === $constants.input.type.checklist" :input="input" :flag="flag" v-on:change="onChange" />

	</div>

	<div class="input-suffix" v-if="input.text.suffix">{{ input.text.suffix }}</div>

	<com-info v-if="input.info" :info="input.info" />

</div>

</template>

<script>

import comToggle from './input/Toggle'
import comTextbox from './input/Textbox'
import comDate from './input/Date'
import comSelect from './input/Select'
import comScale from './input/Scale'
import comChecklist from './input/Checklist'

import comInfo from './Info'

export default {

	props: ['input', 'force', 'dark'],

	components: {
		'com-toggle': comToggle,
		'com-textbox': comTextbox,
		'com-date': comDate,
		'com-select': comSelect,
		'com-info': comInfo,
		'com-scale': comScale,
		'com-checklist': comChecklist
	},

	computed: {

		isLocked: function() {

			return this.input.automated.enabled

		},

		isVisible: function() {

			return (this.input.manual || this.force) ? true : this.visible(this.input)

		},

		flag: function() {

			return (this.input.manual) ? false : this.$_.contains(this.$store.getters['session/inputs/flagged'], this.input.id)

		}

	},

	watch: {

		isVisible: function() {

			this.$store.dispatch('set', {
				input: this.input.id,
				variable: this.input.variable, 
				value: null
			})

		}

	},

	methods: {

		onChange: function(value) {

			this.$emit('change', value)

		}

	}

}

</script>

<style scoped>

.input {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 32px;
}

.input.is-small {
	width: 100px;
}

.input.is-locked {
	pointer-events: none;
}

.input.is-stacked,
.is-mobile .input {
	flex-direction: column;
	margin-bottom: 16px;
	align-items: flex-start;
}

.input-label {
	min-height: 48px;
	padding-right: 20px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	flex-grow: 1;
}

.is-mobile .input-label {
	min-height: auto;
	padding-right: 32px;
	margin-bottom: 10px;
	flex-direction: column;
	align-items: flex-start;
}

.input-label-title {
	color: #343434;
	font-size: 20px;
	line-height: 24px;
	font-weight: 400;
}

.input.is-dark .input-label-title {
	color: #fff;
}

.is-mobile .input-label-title {
	font-size: 14px;
	line-height: 18px;
}

.input-label-description {
	color: #343434;
	font-size: 16px;
	line-height: 19px;
	font-weight: 100;
}

.input.is-dark .input-label-description {
	color: #fff;
}

.is-mobile .input-label-description {
	font-size: 12px;
	line-height: 16px;
}

.input-content {
	height: 48px;
	flex-shrink: 0;
}

.input.is-stacked .input-content,
.is-mobile .input-content {
	height: auto;
	width: 100%;
}

.input-suffix {
	padding-left: 10px;
	font-size: 20px;
}

</style>